import script from "./ProductCardV2.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductCardV2.vue?vue&type=script&lang=ts&setup=true"

import _style_0 from "./ProductCardV2.vue?vue&type=style&index=0&id=7443f581&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['styles',[_style_0]],['__scopeId',"data-v-7443f581"]])

export default __exports__